export function buildClientDetails() {
    return {
        id: 1,
        title: 'Client Details',
        subtitle: 'Provide us with your details',
        attention: false,
        status: 'SuccessfullyCompleted',
        route: '/tasks/client-details/',
        createdDate: new Date('1900-01-01')
    }
}
